import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OvVideoLink from '../atoms/OvVideoLink';
import OvVideoStateNotice from './OvVideoStateNotice';
import { AdminVideo } from '../../../common/model/dto/video/admin-video';

interface OvVideoReplacesNoteProps {
  replacedId: string;
  replaced?: AdminVideo;
  takesOver: boolean;
}

const OvVideoReplacesNote: FC<OvVideoReplacesNoteProps> = ({
  replacedId,
  replaced,
  takesOver,
}) => {
  const { t } = useTranslation();

  return (
    <OvVideoStateNotice notice={{ kind: 'replacesVideo', takesOver }}>
      <OvVideoLink videoId={replacedId}>
        {replaced?.title ?? t('videos.replace.openReplaced')}
      </OvVideoLink>
    </OvVideoStateNotice>
  );
};

export default OvVideoReplacesNote;
